/* eslint-disable react/jsx-key */
import React from "react";
import { LargeBreak, MediumBreak, SmallBreak } from "../helpers";

export const services: IServices[] = [
  {
    id: "__services_01__",
    name: <React.Fragment>Organizational Leadership</React.Fragment>,
    image: "/images/services/org-leadership.webp",
    description: (
      <React.Fragment>
        Create meaningful change and reach <SmallBreak /> your leadership goals with our{" "}
        <SmallBreak />
        Org Leadership Coaching.
      </React.Fragment>
    ),
    type: "Confidence",
    goals: [
      "Improving communication skills",
      "Building stronger relationships with team members",
      "Building a diverse and inclusive workplace",
    ],
  },
  {
    id: "__services_02__",
    name: (
      <React.Fragment>
        Mental Health <SmallBreak /> and Wellbeing
      </React.Fragment>
    ),
    image: "/images/services/well-being.webp",
    description: (
      <React.Fragment>
        Our specialized Mental Health and Well-being <MediumBreak /> coaching program, is designed
        to support <MediumBreak /> clients in overcoming mental health and well-being obstacles that
        may be hindering their progress towards their goals.
      </React.Fragment>
    ),
    type: "balance",
    goals: ["Stress management", "Addressing anxiety", "Overcoming procrastination"],
  },
  {
    id: "__services_03__",
    name: <React.Fragment>Career Coaching</React.Fragment>,
    image: "/images/services/career-coaching.webp",
    description: (
      <React.Fragment>
        Career coaching is a type of personal coaching that <LargeBreak /> helps individuals attain
        higher levels of career fulfillment <LargeBreak /> and satisfaction.
      </React.Fragment>
    ),
    type: "sUCCESS",
    goals: [
      "Achieving a healthy work-life balance",
      "Continuously learning and growing professionally",
      "Building positive relationships with colleagues",
    ],
  },

  {
    id: "__services_04__",
    name: <React.Fragment>Personal Development</React.Fragment>,
    image: "/images/services/personal.webp",
    description: (
      <React.Fragment>
        Our specialized Personal Development Coaching <LargeBreak /> program is designed to provide
        clients with the <LargeBreak /> necessary tools and techniques to enhance their{" "}
        <LargeBreak /> personal growth and development.
      </React.Fragment>
    ),
    type: "POTENTIAL",
    goals: [
      "Cultivating a growth mindset",
      "Building healthy habits and breaking negative ones",
      "Making SMART goals and visualizing them",
    ],
  },
  {
    id: "__services_05__",
    name: <React.Fragment>Performance Coaching</React.Fragment>,
    image: "/images/services/performance.webp",
    description: (
      <React.Fragment>
        Providing guidance, support, and feedback to individuals or teams to help them achieve their
        professional goals and improve their performance.
      </React.Fragment>
    ),
    type: "impact",
    goals: [
      "Increasing productivity and efficiency",
      "Professional growth and learning that persists",
      <React.Fragment>
        Enhancing decision-making and <LargeBreak /> problem-
        <MediumBreak />
        solving abilities
      </React.Fragment>,
    ],
  },
  {
    id: "__services_06__",
    name: (
      <React.Fragment>
        Interpersonal <SmallBreak /> Relations Coaching
      </React.Fragment>
    ),
    image: "/images/services/interpersonal.webp",
    description: (
      <React.Fragment>
        Individuals gain clarity on relational matters, learn to manage biases, and develop
        strategies for building <LargeBreak /> trust and positive relationships.
      </React.Fragment>
    ),
    type: "build",
    goals: [
      "Improved workplace relationships",
      "Enhanced communication",
      "Increased empathy and emotional intelligence",
    ],
  },
];

export interface IServices {
  id: string;
  name: React.ReactNode;
  image: string;
  description: React.ReactNode;
  type: string;
  goals: Array<string | React.ReactNode>;
}
